import { BrandMark } from '@dnx/ui';
import { HeartPulse, MessagesSquare, ShieldCheck, Signature } from 'lucide-react';
import type { ReactNode } from 'react';

const HIGHLIGHTS = [
  { Icon: MessagesSquare, title: 'Atendimento 24 h', text: 'Assistente virtual no WhatsApp, com a equipe assumindo quando precisa.' },
  { Icon: Signature, title: 'Prontuário cirúrgico', text: 'Avaliação, enxertos e registro intraoperatório com assinatura digital.' },
  { Icon: HeartPulse, title: 'Pós-operatório de 12 meses', text: 'Acompanhamento por fase, fotos de evolução e alerta de intercorrências.' },
];

export function AuthLayout({ title, description, children, footer }: {
  title: string; description?: ReactNode; children: ReactNode; footer?: ReactNode;
}) {
  return (
    <div className="grid min-h-dvh lg:grid-cols-[minmax(0,1.05fr)_minmax(0,1fr)]">
      <aside className="relative hidden overflow-hidden bg-[oklch(0.3_0.055_220)] text-white lg:flex lg:flex-col lg:justify-between lg:p-12">
        <div aria-hidden className="pointer-events-none absolute inset-0 opacity-[0.5]"
          style={{
            backgroundImage:
              'radial-gradient(60rem 40rem at 110% -10%, oklch(0.55 0.1 200 / 0.55), transparent 60%),' +
              'radial-gradient(40rem 30rem at -20% 110%, oklch(0.6 0.12 70 / 0.25), transparent 60%)',
          }} />
        <BrandMark className="relative [&_span]:text-white [&_span_span]:text-white/70 [&_rect]:fill-white/15" />
        <div className="relative max-w-md">
          <h1 className="text-[2rem] leading-tight font-semibold tracking-tight text-balance">
            A operação da clínica, do primeiro contato ao 12º mês de pós-operatório.
          </h1>
          <ul className="mt-10 space-y-6">
            {HIGHLIGHTS.map(({ Icon, title, text }) => (
              <li key={title} className="flex gap-4">
                <span className="grid size-10 shrink-0 place-items-center rounded-lg bg-white/10 ring-1 ring-white/15">
                  <Icon className="size-5" aria-hidden />
                </span>
                <div>
                  <p className="font-medium">{title}</p>
                  <p className="mt-0.5 text-sm text-white/70">{text}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <p className="relative flex items-center gap-2 text-xs text-white/60">
          <ShieldCheck className="size-4" aria-hidden />
          Dados de saúde protegidos conforme LGPD · acesso auditado
        </p>
      </aside>

      <main className="flex flex-col px-4 py-8 sm:px-8">
        <BrandMark className="lg:hidden" />
        <div className="mx-auto flex w-full max-w-[400px] flex-1 flex-col justify-center py-10">
          <h2 className="text-2xl font-semibold tracking-tight text-fg">{title}</h2>
          {description && <p className="mt-2 text-sm text-fg-muted">{description}</p>}
          <div className="mt-8">{children}</div>
        </div>
        {footer && <div className="mx-auto w-full max-w-[400px] text-center text-xs text-fg-subtle">{footer}</div>}
      </main>
    </div>
  );
}
